import { Container, Grid, TextField } from "@mui/material";
import { ChangeEvent, useState } from "react";
import { TutorialDto, TutorialService } from "../../../api/psc";
import { PageHeader, Spinner } from "../../../components/exports";
import useDynamicList from "../../../hooks/UseDynamicList";
import TutorialItem from "../components/TutorialItem";

export default function ListTutorials() {
    const [term, setTerm] = useState("");

    const manager = useDynamicList<TutorialDto>(async (offset) => {
        return TutorialService.listTutorials("1");
    });

    const handleSearchTermChange = (
        elem: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setTerm(elem.target.value);
    };

    if (manager.requestInProgress) {
        return <Spinner />;
    }

    return (
        <Container maxWidth="lg">
            <PageHeader
                title="ویدئوهای آموزشی"
                action={
                    <TextField
                        size="small"
                        value={term}
                        label="جستجو در ویدیو ها"
                        onChange={handleSearchTermChange}
                    />
                }
            />

            <Grid container spacing={2}>
                {manager.results
                    .filter(
                        (t) =>
                            term.length === 0 ||
                            t.title.includes(term) ||
                            t.tag.includes(term) ||
                            t.category.includes(term)
                    )
                    .map((t) => (
                        <Grid item xs={12} sm={12} md={4} key={t.id}>
                            <TutorialItem item={t} />
                        </Grid>
                    ))}
            </Grid>
        </Container>
    );
}
